import { render, staticRenderFns } from "./IconWorkoutLinear.vue?vue&type=template&id=4f4a0338&scoped=true"
import script from "./IconWorkoutLinear.vue?vue&type=script&lang=js"
export * from "./IconWorkoutLinear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4a0338",
  null
  
)

export default component.exports